import React from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import styles from './WarningPanel.module.scss'

const WarningPanel = ({ children }) => (
  <div className={styles['message-warning']}>
    <Icon
      className={styles['icon']}
      colour={IconType.colour.task}
      name={IconType.iconName.danger}/>
    {children}
    <span>Please close this tab &frasl; window.</span>
  </div>
)

export default WarningPanel
